export default "__VITE_ASSET__20fc328d__"